module.exports = __webpack_public_path__ + "static/media/logo.1bc2f8bf.png";